import api from 'api'
import { VACATIONS_RECIEVED, VACATION_SAVED, VACATION_DELETED, VACATION_UNLOADED } from './types'

export const vacationSaved = data => ({
  type: VACATION_SAVED,
  data
})

export const vacationDataRecieved = data => ({
  type: VACATIONS_RECIEVED,
  data
})

export const vacationDeleted = data => ({
  type: VACATION_DELETED,
  data
})

export const vacationDataUnload = () => ({
  type: VACATION_UNLOADED
})

export const unloadVacations = () => dispatch => {
  dispatch(vacationDataUnload())
}

export const deleteVacation = data => dispatch =>
  api.bmc.activities.deleteActivity(data).then(()=>{
    dispatch(vacationDeleted(data))
  })

export const getVacations = planid => dispatch =>
  api.bmc.activities.getActivities(planid, 'vacation').then(res => {
    dispatch(vacationDataRecieved(res))
  })

export const saveVacation = data => dispatch =>
  api.bmc.activities.postActivity(data).then(res=> {
    dispatch(vacationSaved(res))
    return res.id
  })
